import { render, staticRenderFns } from "./CertificationBadge.vue?vue&type=template&id=5101d879&scoped=true"
import script from "./CertificationBadge.vue?vue&type=script&lang=js"
export * from "./CertificationBadge.vue?vue&type=script&lang=js"
import style0 from "./CertificationBadge.vue?vue&type=style&index=0&id=5101d879&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5101d879",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5101d879')) {
      api.createRecord('5101d879', component.options)
    } else {
      api.reload('5101d879', component.options)
    }
    module.hot.accept("./CertificationBadge.vue?vue&type=template&id=5101d879&scoped=true", function () {
      api.rerender('5101d879', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/serviceLocation/components/CertificationBadge.vue"
export default component.exports